import { makeStyles } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  skeleton: {
    background: theme.palette.dark[600],
    '@media(max-width: 1582px)': {
      height: '12.4vw',
      width: '18vw',
    },
    '@media(min-width: 2560px)': {
      maxWidth: '19vw',
    },
    '@media(min-width: 3000px)': {
      height: '9.5vw',
      maxWidth: '14vw',
    },
    '@media(max-width: 1024px)': {
      minWidth: 160,
      minHeight: 169,
    },
    width: '18.5vw',
    height: '12.826vw',
    borderRadius: 8,
    marginRight: theme.spacing(4),
  },
}));

interface IProps {
  single?: boolean;
}

const SkeletonList = (props: IProps) => {
  const classes = useStyles();

  if (props?.single) {
    return <Skeleton className={classes.skeleton} variant='rect' />;
  }

  return (
    <div className={classes.container}>
      {Array.from(Array(5)).map((id, index) => (
        <Skeleton key={index} className={classes.skeleton} variant='rect' />
      ))}
    </div>
  );
};

export default SkeletonList;
